import config from './config';
import { loadGsiClient, initCodeClient } from './utils';

export default {
	install (Vue, options) {
		Vue.prototype.$gsiClientLoaded = false;

		if (options.clientId && !Vue.prototype.$gsiClientLoaded) {
			loadGsiClient(config).then(google => {
				Vue.prototype.$gsiClientLoaded = true;
			}).catch(error => {
				Vue.prototype.$gsiClientLoaded = false;
				console.error(error);
			});
		}

		async function getGsiClient () {
			if (Vue.prototype.$gsiClientLoaded && window.google) {
				return window.google;
			}

			return loadGsiClient(config);
		}

		Vue.prototype.$initGoogleCodeClient = async function (params = { uxMode: 'popup' }) {
			const google = await getGsiClient();

			return initCodeClient(google, { clientId: options.clientId }, params);
		};
	}
};
